(() => {
  async function init(layout) {
    if (layout.dataset.kbPlasticUnified === 'true') return;
    if (layout.dataset.pickerReady) return;
    const picker = layout.querySelector('[data-kb-option-picker]');
    const master = layout.querySelector('[data-kb-variants]');
    const json = layout.querySelector('[data-kb-variant-json]');
    if (!picker || !master || !json) return;
    layout.dataset.pickerReady = 'true';
    const form = master.closest('form');
    const buy = form.querySelector('[name="add"]');
    const status = layout.querySelector('[data-kb-picker-status]');
    const controls = [...picker.querySelectorAll('[data-kb-option-index]')];
    let variants = JSON.parse(json.textContent);
    const pages = Number(layout.dataset.kbVariantPages || 1);
    buy.disabled = true;
    let loading = true;
    // Also block Enter-key submission while additional variant pages are loading.
    form.addEventListener('submit', event => { if (loading) event.preventDefault(); });
    if (pages > 1) { status.hidden = false; status.textContent = 'Kleuren en aantallen laden…'; }
    try {
      const replies = await Promise.all(Array.from({length: pages}, (_, i) => i + 1).filter(page => page !== Number(layout.dataset.kbVariantPage || 1)).map(async page => {
        const url = new URL(layout.dataset.kbProductUrl, location.origin);
        url.searchParams.set('section_id', 'kb-variant-data');
        url.searchParams.set(layout.dataset.kbPageParam || 'page', String(page));
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Variant page unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = html.querySelector('[data-kb-page-json]');
        if (!data) throw new Error('Variant page missing');
        return JSON.parse(data.textContent).variants;
      }));
      variants = [...new Map([...variants, ...replies.flat()].map(variant => [String(variant.id), variant])).values()];
      const expected = Number(layout.dataset.kbVariantCount || 0);
      if (expected && variants.length !== expected) throw new Error('Onvolledige variantgegevens');
      json.textContent = JSON.stringify(variants);
      const initial = variants.find(v => String(v.id) === layout.dataset.kbSelectedVariant)
        || variants.find(v => v.available) || variants[0];
      master.replaceChildren(...variants.map(v => {
        const option = document.createElement('option');
        option.value = String(v.id);
        option.textContent = v.title + ' — ' + v.price + (v.available ? '' : ' (Uitverkocht)');
        return option;
      }));
      master.value = String(initial.id);
      const masterLabel = layout.querySelector('label[for="' + master.id + '"]');
      if (masterLabel) masterLabel.hidden = true;
      master.hidden = true;
      function sync() {
        const selected = variants.find(v => String(v.id) === master.value);
        if (!selected) return;
        controls.forEach((control, i) => {
          control.value = selected.options[i];
          // Keep all real choices selectable, even when another choice must adjust.
          [...control.options].forEach(option => {
            option.disabled = !variants.some(v => v.options[i] === option.value);
          });
        });
      }
      controls.forEach((control, index) => control.addEventListener('change', () => {
        const current = controls.map(control => control.value);
        const candidates = variants.filter(v => v.options[index] === current[index]);
        const score = v => v.options.reduce((sum, value, i) => sum + (value === current[i] ? (i === 2 ? 10 : 2) : 0), 0);
        candidates.sort((a,b) => score(b) - score(a) || Number(b.available) - Number(a.available));
        if (!candidates.length) return;
        master.value = String(candidates[0].id);
        master.dispatchEvent(new Event('change', {bubbles:true}));
      }));
      master.addEventListener('change', sync);
      loading = false;
      layout.dispatchEvent(new CustomEvent('kb:variants-ready', {bubbles:true}));
      master.dispatchEvent(new Event('change', {bubbles:true}));
      sync();
      picker.hidden = false;
      status.hidden = true;
      // The theme's delegated change handler updates the price and buy button.
    } catch(error) {
      status.hidden = false;
      status.textContent = 'De kleuren en aantallen konden niet volledig worden geladen. Vernieuw deze pagina om opnieuw te proberen.';
      buy.disabled = true;
    }
  }
  function boot() { document.querySelectorAll('.product-layout[data-kb-variant-pages]').forEach(init); }
  boot(); document.addEventListener('shopify:section:load', boot);
})();
